import React, { useEffect, useMemo, useState } from 'react'
import { useFakeData } from '@/api/fakeData/useFakeData'
import ScreenHeader from '@/components/ScreenHeader';
import BackBtn from '../shared/backBtn/BackBtn';
import PatientSummaryHeader from './components/SummaryHeader/PatientSummaryHeader';
import Classification from './components/Classification/Classification';
import Complaint from './components/complaint/Complaint';
import Biometric from './components/Biometric/Biometric';
import FamilyDocumentsSection from './components/familyDocuments';
import { useTranslation } from 'react-i18next';
import CaseSkeleton from './components/CaseSkeleton';
import { useParams } from 'react-router-dom';

import { useGet } from '@/api/hooks/useGet';
import { GetAMDetails } from "@/api/endpoints";


const PatientCaseFile = () => {
  const { t } = useTranslation();
  const { id } = useParams()
  const { result: data, isPending } = useGet({
    endPoint: GetAMDetails,
    depArr: [id],
    allowFetch: !!id,
    params: [id]
  });




  if (isPending) {
    return <CaseSkeleton />;
  }
  return (
    <div className='d-flex flex-column gap-3 mx-md-5 mx-2'>
      <BackBtn title={t("back-to-request")} />
      <ScreenHeader title={"patient-case-file"} subtitle={"patient-case-file-sub"} className="bg-transparent mx-0 px-0" />
      <PatientSummaryHeader data={data} />
      <Classification data={data} />
      <Complaint data={data} />
      <Biometric data={data} />
      <FamilyDocumentsSection data={data} />
    </div>
  )
}

export default PatientCaseFile